jQuery(document).ready(function ($) {
    //FAQ Accordion Changes
    let timing = 300;
    let questionDiv = $('#FAQ .faq-q');
    let answerDiv = $('.faq-a');

    $(questionDiv).click(function() {
        if ($(this).children(answerDiv).hasClass('openFAQ')) {
            $(this).removeClass('active');
            $(this).children(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
        } else if ($(answerDiv).hasClass('openFAQ')) {
            $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
            $(questionDiv).not(this).removeClass('active');
            $(this).addClass('active');
            $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
        } else {
            $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
            $(this).addClass('active');
        }
    });
    //End of FAQ Accordion changes
});
